import client from '../../client'

const me = params => {
  return client.get(`api/v1/users/me`, params);
}

export {
  me
}



// WEBPACK FOOTER //
// ./src/store/api/user.js